// Processes idToken

import jwtDecode from 'jwt-decode';
import StatusCodes from 'http-status';

// Extract data from jwt
const processToken = (idToken) => {
	const parsedToken = jwtDecode(idToken);
	if( !parsedToken['cognito:groups']) throw new Error(StatusCodes.FORBIDDEN);
	const firstName = parsedToken['custom:firstName'];
	const FirstName = `${firstName[0].toUpperCase()}${firstName.substring(1)}`;
	const lastName = parsedToken['custom:lastName'];
	const LastName = `${lastName[0].toUpperCase()}${lastName.substring(1)}`;
	const authorString = `${FirstName} ${LastName}`;
	// Save idToken to
	return {
		userType: parsedToken['cognito:groups'][0],
		userId: parsedToken['cognito:username'],
		orgId: parsedToken['custom:orgId'],
		firstName,
		lastName,
		authorString,
		exp: parsedToken.exp,
	};
};

export default processToken;